<script>
import { BRow, BCol } from 'bootstrap-vue'
import FMD from "@/views/product/components/product-card/fmd/FMD.vue";
import MaterialWeightSummary from "@/views/product/components/product-card/fmd/MaterialWeightSummary.vue";
import {ProductWeight} from "@/views/product/components/product-card/common/characteristics";

export default {
    components: {
        FMD, BRow, BCol, ProductWeight, MaterialWeightSummary,
    },
    props: {
        productId: {
            type: [String, Number],
            required: true
        },
        declarations: {
            type: Array,
            default() {
                return [];
            },
        },
        productWeight: {
            type: [Number, String, null],
            default: null,
        },
        getSubstanceLists: {
            type: Function,
            default: null,
        },
        showProductWeight: {
            type: Boolean,
            default: false
        },
        requireSubstance: {
            type: Boolean,
            default: false,
        },
    }
}
</script>

<template>
    <div>
        <b-row class="align-items-end" v-if="showProductWeight">
            <b-col md="4" lg="4">
                <ProductWeight
                    :value="productWeight"
                    :required="true"
                    @input="$emit('weightChange', $event)"
                />
            </b-col>
            <b-col md="8" lg="8">
                <MaterialWeightSummary
                    :declarations="declarations"
                />
            </b-col>
        </b-row>
        <b-row v-else>
            <b-col>
                <MaterialWeightSummary
                    :declarations="declarations"
                />
            </b-col>
        </b-row>
        <FMD
            :product-id="productId"
            :declarations="declarations"
            :get-substance-lists="getSubstanceLists"
            :require-substance="requireSubstance"
            @change="$emit('declarationChange', $event)"
        />
    </div>
</template>

<style scoped lang="scss">

</style>
